module.exports = __webpack_public_path__ + "img/owl-graduate.744e5d01.gif";